module.exports = __webpack_public_path__ + "img/ucpa.1917a41d.svg";